import clientWrapper from './client_wrapper.js'
import repository from './repository.js'

const repositoryFolder = 'repositories'

const repositories = [
  'auth',
  'batches',
  'editorial',
  'instagram',
  'issues',
  'media',
  'options',
  'previews',
  'resources',
  'resourceNotifications',
  'search',
  'user'
]

export default () => {
  return repositories.reduce((acc, repoName) => {
    try {
      const repositoryBuilder = require(`./${repositoryFolder}/${repoName}`)
      acc[repoName] = repositoryBuilder.default({ clientWrapper, repository, context: window.$nuxt })
    }
    catch(_err) {
      acc[repoName] = {}
    }
    return acc
  }, {})
}
